import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'

// Toast notifications
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

// Tailwind CSS
import './assets/css/main.css'

const app = createApp(App)
app.use(createPinia())

import { useAuthStore } from '@/store/modules/auth'
import { useWishlistStore } from '@/store/modules/wishlist'

const authStore = useAuthStore()

// Wait to fetch user profile before starting router
authStore.initializeAuth().finally(() => {
  const wishlistStore = useWishlistStore()
  wishlistStore.fetchWishlist()
})

app.use(router)
app.use(Toast, {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: false,
})

app.mount('#app')

